import type { FC } from 'react';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import Lozenge from '@atlaskit/lozenge/lozenge';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StatusLozengeWrapper = styled.span({
	marginLeft: token('space.050'),
	fontStyle: 'normal',
	flex: 1,
});

export const i18n: {
	draftLozengeTextUpdated: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	draftLozengeTextUpdated: {
		id: 'page-tree.status.draft.updated',
		defaultMessage: 'Draft',
		description: 'User has started a page but has not published it yet',
	},
});

export const DraftLozenge: FC = () => (
	<StatusLozengeWrapper>
		<Lozenge appearance="neutral">
			<FormattedMessage {...i18n.draftLozengeTextUpdated}>
				{(message) => <span data-testid="draft-status-lozenge">{message}</span>}
			</FormattedMessage>
		</Lozenge>
	</StatusLozengeWrapper>
);
